import React from 'react';
import { Container, Text } from '@pixi/react';
import { applicationStore } from '../../../../../store/applicationStore';

function BoostedJackpotInfoPopupWinCount({ winningCount, winningCountLeft }) {
  const {
    canvasTranslationKeys: { WINNING_COUNT, WINNERS_COUNT_LEFT },
  } = applicationStore;

  return (
    <Container name='BoostedJackpotInfoPopupWinCount'>
      <Container x={70} y={100}>
        <Text
          anchor={0.5}
          text={WINNING_COUNT}
          style={{
            fontSize: 11,
            fontWeight: 700,
            fontFamily: 'poppinsMedium',
            fill: '#FFFFFF',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 206,
          }}
          resolution={2}
        />
        <Text
          y={25}
          anchor={0.5}
          text={`${winningCount}+`}
          style={{
            fontSize: 17,
            fontWeight: 700,
            fontFamily: 'poppinsMedium',
            fill: '#FFC33E',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 206,
          }}
          resolution={2}
        />
      </Container>
      <Container x={380} y={100}>
        <Text
          anchor={0.5}
          text={WINNERS_COUNT_LEFT}
          style={{
            fontSize: 11,
            fontWeight: 700,
            fontFamily: 'poppinsMedium',
            fill: '#FFFFFF',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 206,
          }}
          resolution={2}
        />
        <Text
          y={25}
          anchor={0.5}
          text={winningCountLeft}
          style={{
            fontSize: 17,
            fontWeight: 700,
            fontFamily: 'poppinsMedium',
            fill: '#FFC33E',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 206,
          }}
          resolution={2}
        />
      </Container>
    </Container>
  );
}

export default BoostedJackpotInfoPopupWinCount;
